import { render, staticRenderFns } from "./UserEditChangePassword.vue?vue&type=template&id=aa3126e8&scoped=true&"
import script from "./UserEditChangePassword.vue?vue&type=script&lang=js&"
export * from "./UserEditChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./UserEditChangePassword.vue?vue&type=style&index=0&id=aa3126e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3126e8",
  null
  
)

export default component.exports